/**
 * (Группа 8) Аудит и проверка цепочки.
 *
 * Реально частично: REAL GET /v1/admin/tenants/{id}/audit (просмотр цепочки
 * по отелю). Cross-tenant запуск проверки (verify) — TODO backend
 * (/v1/admin/audit/verify отсутствует).
 */
import { PageStub } from '../../shared/PageStub.js';

export function AuditPage(): JSX.Element {
  return (
    <PageStub
      testId="audit-page"
      title="Аудит и проверка цепочки"
      description="Криптографически связанные записи аудита, проверка целостности, история проверок."
      sections={[
        'Просмотр аудит-цепочки: хэши, фильтры, навигация по связям',
        'Форма проверки: выбор отеля, диапазон дат, опции (хэши/подписи/re-hash)',
        'Результат OK: целостность подтверждена, число записей, время',
        'Результат FAIL: позиция разрыва, ожидаемый vs фактический хэш, причина',
        'История проверок: дата, исполнитель, период, результат',
      ]}
      dataSource="REAL GET /v1/admin/tenants/{id}/audit; cross-tenant verify — TODO backend (/v1/admin/audit/verify)"
    />
  );
}
